import { environment } from './../../../environments/environment';
import { Component, OnInit } from '@angular/core';
import { ApiAnnuaireService } from '../../annuaire/services/api-annuaire.service';
import { Router, ActivatedRoute } from '../../../../node_modules/@angular/router';

@Component({
  selector: 'app-za-listing',
  templateUrl: './listing.component.html',
  styleUrls: ['./listing.component.css']
})
export class ListingEntreprisesComponent implements OnInit {
  criteres;
  paged: number = 1;
  loading = false;
  
  entreprises = [];
  idZone;

  base_url_annuaire = '';

  constructor(public _apiService: ApiAnnuaireService, private _router: Router, private _activatedRoute: ActivatedRoute) {
    this.base_url_annuaire = environment.base_url_annuaire;
  }

  ngOnInit() {
    this._activatedRoute.data
      .subscribe((data: { local: any }) => {
        this.entreprises = data.local.entreprises;
        this.idZone = data.local.idZone;
      });
  }

  onClickMoreResults() {
    console.log('more');
    this.paged++;
    this.loading = true;

    this._apiService.getEntreprisesByZone(this.idZone, this.paged).then(results => {
      if (results) {
        console.log('resultssss:', results);
        if(results.length > 0) {
          this.entreprises = this.entreprises.concat(results);
        }
        
        this.loading = false;
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/zone-activite/listing/listing.component.ts